import type { IsSunriseEnabledProps } from './isSunriseEnabledState';
import type { VariantState } from './variantState';

import type { Props } from './index';

export type SelectionProps = IsSunriseEnabledProps & {
	checked: boolean;
};

export type SelectionState = IsSunriseEnabledProps & {
	shouldHideRadioButtons: boolean;
	shouldShowSelectionBorder: boolean;
} & VariantState;

export function isSelectionState(props: Props): props is SelectionProps {
	return 'checked' in props;
}

export function selectionState(
	isSunriseEnabled: boolean,
	checked: boolean,
	variant: string | undefined,
): SelectionState {
	return {
		isSunriseEnabled,
		shouldHideRadioButtons: variant !== 'variant_1',
		shouldShowSelectionBorder: variant === 'variant_2' && !checked,
		variant,
	};
}
